import { render, staticRenderFns } from "./Benefits.vue?vue&type=template&id=e1f72ace&scoped=true&"
var script = {}
import style0 from "./Benefits.vue?vue&type=style&index=0&id=e1f72ace&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f72ace",
  null
  
)

export default component.exports